import React from "react";
import { Link } from "react-router-dom";

export default function LatestStories({ latestStoriesData }) {
  return (
    <Link
      to={`/our-publications/${latestStoriesData?.slug}/`}
      reloadDocument={true}
    >
      <div className="relative">
        <img
          className="w-[500px] h-[250px] xs:h-[300px] md:h-[250px] lg:h-[200px] xl:h-[300px] object-cover object-top"
          src={
            latestStoriesData?.cover?.formats?.large?.url ||
            latestStoriesData?.cover?.url
          }
          alt={latestStoriesData?.cover?.alternativeText}
        />
        <div className="w-full h-[20px] xs:h-[50px] bg-white" />
        <Link
          to={`${latestStoriesData?.author?.profile_link}`}
          reloadDocument={true}
          onClick={(e) => {
            e.stopPropagation();
          }}
          className="flex flex-row gap-4 pt-4 w-[90%]  items-center absolute bottom-4 left-0 bg-white px-3 py-1"
        >
          <img
            className="rounded-full h-10 w-10"
            src={
              latestStoriesData?.author?.avatar?.formats?.large?.url ||
              latestStoriesData?.author?.avatar?.url
            }
            alt={latestStoriesData?.author?.avatar?.alternativeText}
          />
          <div>
            <h3 className="font-[optima-lt-pro] text-lg  uppercase">
              {latestStoriesData?.author?.name}
            </h3>
            <h3 className="font-[lato] text-sm font-normal text-bhagwa">
              {latestStoriesData?.author?.designation}
            </h3>
          </div>
        </Link>
      </div>
      <div className="flex flex-row justify-between mt-3 font-[lato] text-sm tracking-wider">
        <span className="text-bhagwa">
          {new Date(latestStoriesData?.published_date).toLocaleDateString()}
        </span>
      </div>
      <div className="flex flex-col gap-2">
        <h2 className="font-[optima-lt-pro] text-2xl xl:text-3xl mt-3 line-clamp-3">
          {latestStoriesData?.title}
        </h2>

        <p className="sm:text-sm md:text-base lg:text-lg  xs-base  font-[lato] font-light line-clamp-3">
          {latestStoriesData?.description}
        </p>
        <button className="flex flex-row items-center font-[lato] gap-1 mt-4 text-bhagwa text-xs uppercase group ">
          {"Read More"}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            className="size-6 transition-all duration-300 group-hover:translate-x-1"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3"
            />
          </svg>
        </button>
      </div>
    </Link>
  );
}
